import { fmtUSD, fmtGRX } from './format';
import { PLAN_META, RANK_LABELS } from './constants';

// Act codes from contract:
//  1  register
//  2  invest_real
//  3  invest_virtual
//  4  invest_leader
//  5  roi_accrued
//  6  level_income
//  7  rank_income
//  8  contrib_sponsor
//  9  rewards_claimed
// 10  flexible_withdrawn
// 11  locked_principal_withdrawn
// 12  contrib_claimed
// 13  lock_linked
// 14  bucket_filled
// 15  rank_updated
// 20  blacklisted
// Category slugs used by the filter dropdown on the Home page.
export const ACT_CATEGORIES = [
  { id: 'all',      label: 'All'              },
  { id: 'farming',  label: 'Farming Profit'   }, // actType 5
  { id: 'level',    label: 'Level Income'     }, // actType 6
  { id: 'rank',     label: 'Rank Income'      }, // actType 7
  { id: 'contrib',  label: 'Contributor'      }, // actType 8, 12
  { id: 'invest',   label: 'Investments'      }, // actType 2, 3, 4
  { id: 'claim',    label: 'Claims / Withdraws' }, // actType 9, 10, 11
  { id: 'lock',     label: 'Locks / Ranks'    }, // actType 13, 14, 15
  { id: 'other',    label: 'Other'            }, // actType 1, 20
];

export const categoryOfActType = (actType) => {
  const t = Number(actType);
  if (t === 5)                       return 'farming';
  if (t === 6)                       return 'level';
  if (t === 7)                       return 'rank';
  if (t === 8 || t === 12)           return 'contrib';
  if (t === 2 || t === 3 || t === 4) return 'invest';
  if (t === 9 || t === 10 || t === 11) return 'claim';
  if (t === 13 || t === 14 || t === 15) return 'lock';
  return 'other';
};

export const describeActivity = (ev /*, currentUserId */) => {
  switch (ev.actType) {
    case 1: return { icon: '◆', color: 'neon',
      title: 'Registered',
      detail: `Referrer #${ev.relatedId}` };

    case 2: return { icon: '⚡', color: 'neon',
      title: 'Invested',
      detail: `${fmtUSD(ev.amount)} · ${fmtGRX(ev.netAmount)} · Inv #${ev.relatedId}` };

    case 3: return { icon: '✦', color: 'cyan',
      title: 'Virtual Investment (Gift)',
      detail: `${fmtUSD(ev.amount)} · Inv #${ev.relatedId}` };

    case 4: return { icon: '♛', color: 'cyan',
      title: 'Leader Position (Gift)',
      detail: `${fmtUSD(ev.amount)} · Inv #${ev.relatedId}` };

    case 5: return { icon: '★', color: 'neon',
      title: 'Farming Profit',
      detail: `Inv #${ev.relatedId} · ${fmtUSD(ev.amount)}` };

    case 6: return { icon: '⇡', color: 'cyan',
      title: 'Level Income',
      detail: `${fmtUSD(ev.amount)}${ev.netAmount !== ev.amount ? ` (net ${fmtUSD(ev.netAmount)})` : ''}` };

    case 7: return { icon: '▲', color: 'cyan',
      title: 'Rank Income',
      detail: `${fmtUSD(ev.amount)}` };

    case 8: return { icon: '⊕', color: 'cyan',
      title: 'Contributor Sponsor',
      detail: `${fmtUSD(ev.amount)}` };

    case 9: return { icon: '💠', color: 'neon',
      title: 'Rewards Claimed',
      detail: `${fmtUSD(ev.amount)} → ${fmtGRX(ev.netAmount)}${ev.relatedId > 0n ? ` (fee ${fmtUSD(ev.relatedId)})` : ''}` };

    case 10: return { icon: '↩', color: 'cyan',
      title: 'Flexible Principal Withdrawn',
      detail: `${fmtGRX(ev.amount)} · Inv #${ev.relatedId}` };

    case 11: return { icon: '↩', color: 'cyan',
      title: 'Locked Principal Withdrawn',
      detail: `${fmtGRX(ev.amount)} · Inv #${ev.relatedId}` };

    case 12: return { icon: '⧗', color: 'neon',
      title: 'Contributor Claimed',
      detail: `${fmtUSD(ev.amount)} → ${fmtGRX(ev.netAmount)} (${ev.relatedId} release${ev.relatedId === 1n ? '' : 's'})` };

    case 13: return { icon: '🔒', color: 'cyan',
      title: 'PinkSale Lock Linked',
      detail: `Lock #${ev.amount} · Inv #${ev.relatedId}` };

    case 14: return { icon: '■', color: 'warn',
      title: 'Bucket Filled',
      detail: `Investment #${ev.relatedId} reached ceiling` };

    case 15: return { icon: '▲', color: 'neon',
      title: `Rank Updated · R${ev.amount}`,
      detail: RANK_LABELS[Number(ev.amount)] || '' };

    case 20: return { icon: ev.amount === 1n ? '✕' : '✓', color: ev.amount === 1n ? 'danger' : 'neon',
      title: ev.amount === 1n ? 'Blacklisted' : 'Unblacklisted',
      detail: '' };

    default: return { icon: '•', color: 'dim',
      title: `Event #${ev.actType}`,
      detail: '' };
  }
};

export const timeAgo = (ts) => {
  if (!ts) return '';
  const s = Math.floor(Date.now() / 1000) - Number(ts);
  if (s < 60) return s + 's ago';
  if (s < 3600) return Math.floor(s / 60) + 'm ago';
  if (s < 86400) return Math.floor(s / 3600) + 'h ago';
  return Math.floor(s / 86400) + 'd ago';
};

// keep PLAN_META import warning-safe
export { PLAN_META };
